<template>
  <scroll-center-dialog v-model="opened" applyText="Удалить" @close="close" @apply="save" title="Удалить событие" :scrolled="false">
    <v-card-title class="text-left">
      На мероприятие записано: {{check.records}} человек
    </v-card-title>
  </scroll-center-dialog>
</template>

<script>
import urls from '@/urls/helper.js'
import {loadData, makeGetRequest, makePostRequest} from "@/helper/requests";
import {generateListUidToName} from "@/helper/uidToName";
import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/templates/LoadingAutocomplete.vue";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog.vue";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import {mapActions} from "vuex";

export default {
  name: "Role",
  mixins: [FormErrorsMixin],
  components: { ScrollCenterDialog},
  props: {
    opened: Boolean,
    edit: Boolean,
    docs_data: Object,
    user: Object,
    event: Number,
  },
  data() {
    return {
      check:{records:null},
      value: {
        id: this.id || undefined,
      },

    }
  },

  methods: {
    ...mapActions({
      loadEventsCheck: 'events/loadEventsCheck',
    }),
    save() {
      this.$emit('close', true)
    },
    close() {
      this.$emit('close', false)
    },
  },
  created() {
    // this.loaders.responsible.handler();
    if (this.docs_data.id) {
      this.loadEventsCheck({
        id: this.docs_data.id,
        finalizer: (val) => {
          this.check = val
        },
        catcher: (val) => {
          this.mapErrors(val)
        },
      })
    }
  }
}
</script>

<style scoped>
</style>
